import { SVGAttributes } from "react";

const CrossIcon = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.2427 13.2425L4.75739 4.75726"
        stroke="#CFB2FF"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M13.2427 4.75735L4.7574 13.2426"
        stroke="#FFA686"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CrossIcon;
